import { PplxError } from '#pplx/frontend/common/errors.js';
class InvariantViolationError extends PplxError {
    name = 'InvariantViolationError';
}
export function invariant(condition, 
// eslint-disable-next-line @typescript-eslint/no-explicit-any
message) {
    if (condition) {
        return;
    }
    if (message instanceof PplxError) {
        throw message;
    }
    throw new InvariantViolationError('INVARIANT_VIOLATION_ERROR', {
        message,
    });
}
//# sourceMappingURL=invariant.js.map